import { defineRoute } from "../../common/route.common";
import { loadView } from "../../common/view.common";

export const AssociateRoutes = defineRoute({
    record: {
        route: {
            path: "/associate",
            component: () => loadView(import("./AssociateTable.vue")),
        },
    },
    create: {
        route: {
            component: () => loadView(import("./AssociateCreate.vue")),
            path: "/associate/create",
        },
    },
    update: {
        route: {
            path: "/associate/update/:id",
            component: () => loadView(import("./AssociateUpdate.vue")),
        },
        build(id: string) {
            return `/associate/update/${id}`;
        },
    },
});
